import Vue from "vue";
import Router from "vue-router";
import Auth from '@/fstore/auth';
import User from '@/fstore/collections/User';
import Job from '@/fstore/collections/Job';
import store from '@/store';
import { user } from "firebase-functions/lib/providers/auth";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      name: "home",
      path: "/",
      component: () => import("@/views/Login.vue")
      // meta: {
      //   showMenu: true
      // }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Login.vue"),
      beforeEnter: async(to, from, next) => {
        next({ name: "home" });
      }
    },
    {
      path:"/forgotPassword",
      name: "ForgotPassword",
      component: () => import("@/views/ForgotPassword.vue"),
      beforeEnter: async(to, from, next) => {
        if (Auth.currentUser()){
          // user is logged in, just forward them to their profile
          next({ name: "userProfile" });
        }

        next();
      }
    },
    {
      path: "/register",
      name: "register",
      beforeEnter: async (to, from, next) => {
        next()
        // verificationfailure
        // if (Auth.currentUser()) {
        //   const uid = Auth.ref().currentUser.uid;
        //   try {
        //     const user = await User.getById(uid);
      
        //     if (!user.verified) {
        //       next({ path: "/login", query: { p: "verificationfailure" } });
        //       return;
        //     } else next(`/profile/${firebase.auth().currentUser.uid}`);
        //   } catch (err) {
        //     console.error(err);
        //     next({ path: "/login", query: { p: "verificationfailure" } });
        //   }
        // } else next();
      },
      component: () => import("@/views/Register.vue"),
    },
    {
      path: '/job/:id/public',
      name: 'PublicJobPage',
      component: () => import('@/views/public'),
      beforeEnter: async (to, from, next) => {
        try {
          const job = await Job.getById(to.params.id);
      
          if (job.closed != null) {
            next(false)
            return;
          }
      
          next()
        } catch (err) {
          console.error(err)
        }
      }
    },
    {
      path: "/company/",
      name: "companyProfile",
      component: () => import('@/views/companyProfile.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/setup",
          name: "companySetup",
          component: () => import("@/views/companySetup.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'dashboard',
          name: 'companyDashboard',
          component: () => import('@/components/companyProfile/Dashboard'),
        },
        {
          path: 'info',
          name: 'companyInfo',
          component: () => import('@/components/companyProfile/info'),
        },
        {
          path: 'jobs',
          name: 'companyJobs',
          component: () => import('@/components/companyProfile/Jobs')
        },
        {
          path: 'job/:id/',
          name: 'job',
          redirect: 'job/:id/details',
          component: () => import('@/views/jobDetails'),
          children: [
            { 
              path: 'details',
              name: 'jobDetails',
              component: () => import('@/components/jobDetails/details'),
            },
            {
              path: 'candidates',
              name: 'jobCandidates',
              component: () => import('@/components/jobDetails/candidates')
            },
          ]
        },
        {
          path: 'payments',
          name: 'companyPayments',
          component: () => import('@/components/companyProfile/Payments'),
        }
      ],
    },
    {
      path: "/profile",
      name: "userProfile",
      component: () => import("@/views/Profile.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/admin/",
      name: "adminDashboard",
      component: () => import('@/views/adminDashboard.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: 'users',
          name: 'adminUsers',
          component: () => import('@/components/adminDashboard/users')
        },
        {
          path: 'companies',
          name: 'adminCompanies',
          component: () => import('@/components/adminDashboard/companies')
        },
        {
          path: 'positions',
          name: 'adminPositions',
          component: () => import('@/components/adminDashboard/positions')
        },
        {
          path: 'skills',
          name: 'adminSkills',
          component: () => import('@/components/adminDashboard/skills')
        },
        {
          path: 'privacy',
          name: 'adminPrivacy',
          component: () => import('@/components/adminDashboard/PrivacyPolicy')
        },
        {
          path: 'terms',
          name: 'adminTerms',
          component: () => import('@/components/adminDashboard/TermsAndConditions')
        },
      ]
    },
    {
      path: "/setup/:id",
      name: "setupUser",
      component: () => import("@/views/Verify.vue"),
      beforeEnter: async (to, from, next) => {
        try {
          const user = await User.getById(to.params.id);
      
          if (user.setup) {
            next({ name: 'profile', params: { id: to.params.id } })
            return;
          }
      
          next()
        } catch (err) {
          console.error(err)
        }
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/verify/:id",
      name: "verifyUser",
      component: () => import("@/views/VerifyMessage.vue")
    },
    {
      path: "/verify/company/:id",
      name: "verifyCompany",
      component: () => import("@/views/verifyCompany.vue"),
      beforeEnter: async (to, from, next) => {
        await User.verify(to.params.id);
        next();
      }
    },
    {
      path: "/privacy",
      name: "privacyPolicy",
      component: () => import("@/views/PrivacyPolicy.vue"),
      meta: {
        showMenu: true
      }
    },
    {
      path: "/terms",
      name: "TermsAndConditions",
      component: () => import("@/views/termsAndConditions.vue"),
      meta: {
        showMenu: true
      }
    },
    {
      path: "*",
      name: "404",
      component: () => import("@/views/404.vue")
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Auth.currentUser()) {
      next({ name: "login" });
      return;
    }

    const uid = Auth.currentUser().uid;

    const user = await User.getById(uid);

    if (!user.verified) {
      next({ name: 'login', params: { verificationFailure: true } });
      return;
    }

    // if the route has restrictions on roles, check the role
    const allowedRoles = to.meta.allowedRoles || ['all']

    if (!allowedRoles.includes(user.role) && !allowedRoles.includes('all'))
      next(from);


    next();
    return;
  }
  next();
});

export default router;